import ReactGA from "react-ga4";

export const initializeGA = () => {
  ReactGA.initialize("G-Q83CLWFEFY");
};

export const trackPageView = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};
